import React, { memo } from 'react';
import { View } from 'react-native';
import { rem } from 'design-system';
import IconDown from 'design-system/icons/IconDown';
import Text from 'design-system/Text';
import BlurAmountView from 'design-system/BlurAmountView';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
const FormattedPriceChangePct = ({ priceChangePct }) => {
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const colors = useColors();
    const styles = useStyles(styleSet);
    if (priceChangePct !== undefined) {
        const value = priceChangePct;
        const priceChangeObj = (() => {
            if (value === 0) {
                return {
                    isZero: true,
                    amount: `0.00%`,
                    iconColor: colors.text.secondary,
                    textDecorator: { Secondary: true },
                    iconContainerStyles: styles.neutralIcon,
                };
            }
            if (value > 0) {
                return {
                    iconColor: colors.text.positive,
                    textDecorator: { Green: true },
                    iconContainerStyles: styles.upIcon,
                    amount: `${(value * 100).toFixed(2)}%`,
                };
            }
            return {
                iconColor: colors.text.negative,
                textDecorator: { Red: true },
                iconContainerStyles: styles.downIcon,
                amount: `${(Math.abs(value) * 100).toFixed(2)}%`,
            };
        })();
        return (<View style={styles.row}>
        <View style={priceChangeObj.iconContainerStyles}>
          {priceChangeObj.isZero ? (<View style={styles.neutralIndicator}/>) : (<IconDown color={priceChangeObj.iconColor}/>)}
        </View>
        <BlurAmountView enabled={scrambled}>
          <Text NumbersThin-14 {...priceChangeObj.textDecorator}>
            {priceChangeObj.amount}
          </Text>
        </BlurAmountView>
      </View>);
    }
    // Renders empty priceChangePct if amount is not defined
    return (<Text NumbersThin-14 numberOfLines={1}>
      {' '}
    </Text>);
};
export default memo(FormattedPriceChangePct);
const styleSet = createStyleSheets((colors) => ({
    upIcon: {
        marginRight: rem(6),
        transform: [{ rotate: '180deg' }],
    },
    downIcon: {
        marginRight: rem(6),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    neutralIcon: {
        marginRight: rem(6),
    },
    neutralIndicator: {
        width: rem(4),
        height: rem(4),
        borderRadius: rem(2),
        backgroundColor: colors.text.secondary,
    },
}));
